// extracted by mini-css-extract-plugin
export default {"Government":"Government_Government__YrEe0","governmentIntro":"Government_governmentIntro__V6Wx9","VideoContainer":"Government_VideoContainer__5M+rk"};